module.exports = __webpack_public_path__ + "static/media/biplanes512x384.3e52ff83.jp2";